import { Trans } from "app/utils";
import React from "react";

interface VideoDownloadPageProps {
  videoUrl: string;
}

const VideoDownloadPage: React.FC<VideoDownloadPageProps> = ({ videoUrl }) => (
  <html lang="en" className="videoDownloadPage">
    <head>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Video - File</title>
      <style>
        {`
          html.videoDownloadPage {
            height: 100%;
            background-color: #000 !important;
          }

          html.videoDownloadPage body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #000 !important;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            color: white;
          }

          html.videoDownloadPage video {
            max-width: 100%;
            height: auto;
            border-radius: 4px;
          }

          /* Hide specific controls only */
          html.videoDownloadPage video::-webkit-media-controls-captions-button {
            display: none !important;
          }

          html.videoDownloadPage video::-webkit-media-controls-picture-in-picture-button {
            display: none !important;
          }

          html.videoDownloadPage video::-webkit-media-controls-playback-rate-button {
            display: none !important;
          }

          /* For Firefox */
          html.videoDownloadPage video::-moz-media-controls-captions-button {
            display: none !important;
          }

          html.videoDownloadPage video::-moz-media-controls-picture-in-picture-button {
            display: none !important;
          }

          html.videoDownloadPage video::-moz-media-controls-playback-rate-button {
            display: none !important;
          }
        `}
      </style>
    </head>
    <body>
      <video
        controls
        preload="metadata"
        disablePictureInPicture
      >
        <source src={videoUrl} type="video/mp4" />
        <track kind="captions" src="" label="English" />
        <Trans>Your browser does not support the video tag</Trans>
      </video>
    </body>
  </html>
);

export default VideoDownloadPage;
